import { globalThisShim as globalThis } from "../globalThis.js";
export var nextTick = function () {
  var isPromiseAvailable = typeof Promise === "function" && typeof Promise.resolve === "function";

  if (isPromiseAvailable) {
    return function (cb) {
      return Promise.resolve().then(cb);
    };
  } else {
    return function (cb, setTimeoutFn) {
      return setTimeoutFn(cb, 0);
    };
  }
}();
export var WebSocket = globalThis.WebSocket || globalThis.MozWebSocket;
export var usingBrowserWebSocket = true;
export var defaultBinaryType = "arraybuffer";